// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isInternalUserGroupsInternalUserGroupCreateResult = objectOf({
  id: string,
  name: string,
  property_data: objectOf({
    content_test: objectOf({
      is_enabled: boolean,
      is_default: boolean,
    }),
    seed_group: objectOf({
      is_enabled: boolean,
      is_default: boolean,
    }),
    user_event_log: objectOf({
      is_enabled: boolean,
    }),
    sdk_internal_message_log: objectOf({
      is_enabled: boolean,
    }),
  }),
  territory_ids: arrayOf(nullOrUndefined),
});
